import React from 'react';
import headerImage from '../content/lino.JPG';
import Layout from './layout';
import HeroImage from '../components/HeroImage';

const About = () => {

  return (
    <Layout>
      <HeroImage headerImage={headerImage} title='ABOUT'/>
      {/* Text Section */}
      <section className="flex-grow px-4 font-garet  py-10 bg-cream text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">About Girls Club Teesside</h2>
        <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
        Girls Club Teesside was set up by Danni, a Teessider with a passion for finding new hobbies and meeting new people. She loves to create new events using local suppliers and venues
        to introduce people to their newest hobby. 
        <br/>
        <br/>
        Creating a friendly and low-pressure environment, Danni encourages ladies to attend solo in hopes they can meet their new friends.
        </p>
      </section>

    </Layout>
  );
};

export default About;
